export default __webpack_public_path__ + "static/basic_templates-8d1d3f10c9bb2549e42f1b518b4e26f3.svg";